"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["INITIALIZED"] = "INITIALIZED";
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["ACTIVE"] = "ACTIVE";
    PaymentStatus["DECLINED"] = "DECLINED";
    PaymentStatus["EXPIRED"] = "EXPIRED";
    PaymentStatus["CANCELED"] = "CANCELED";
    PaymentStatus["REFUNDED"] = "REFUNDED";
    PaymentStatus["SUSPENDED"] = "SUSPENDED";
    PaymentStatus["FAILED"] = "FAILED";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
//# sourceMappingURL=payment-status.js.map